import React, { useRef, useEffect, useState } from 'react';
import clsx from 'clsx';
const Canvas = ({ image }) => {
  const canvasRef = useRef(null);
  const [ctx, setCtx] = useState(null);
  const [penColor,setPenColor] = useState("purple")
  const [penSize,setPenSize] = useState(5)

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    setCtx(context);

    // Set initial canvas size
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    // Redraw canvas if the window size changes
    const resizeHandler = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };

    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  useEffect(() => {
    if (ctx) {
      ctx.strokeStyle = penColor;
      ctx.lineWidth = penSize;
    }
  }, [ctx, penColor, penSize]);

  useEffect(() => {
    if (ctx && image) {
      const img = new Image();
     
      img.onload = () => {
        const scaleFactor = Math.min(canvasRef.current.width / img.width, canvasRef.current.height / img.height);
        const x = (canvasRef.current.width - img.width * scaleFactor) / 2;
        const y = (canvasRef.current.height - img.height * scaleFactor) / 2;
        ctx.drawImage(img, x, y, img.width * scaleFactor, img.height * scaleFactor);
      };
      img.src = image;
    }
  }, [ctx, image]);

  const handleColorChange = (colorname) => {
    setPenColor(colorname);
  };
  const handleSizeChange = (e) => {
    setPenSize(e.target.value);
  }
  const handleMouseDown = (e) => {
    const x = e.clientX - canvasRef.current.getBoundingClientRect().left;
    const y = e.clientY - canvasRef.current.getBoundingClientRect().top;
    ctx.beginPath();
    ctx.moveTo(x, y);
    canvasRef.current.addEventListener('mousemove', handleMouseMove);
    canvasRef.current.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (e) => {
    const x = e.clientX - canvasRef.current.getBoundingClientRect().left;
    const y = e.clientY - canvasRef.current.getBoundingClientRect().top;
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const handleMouseUp = () => {
    canvasRef.current.removeEventListener('mousemove', handleMouseMove);
    canvasRef.current.removeEventListener('mouseup', handleMouseUp);
  };

  const handleReset = () => {
    ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    if (image) {
      const img = new Image();
      img.onload = () => {
        const scaleFactor = Math.min(canvasRef.current.width / img.width, canvasRef.current.height / img.height);
        const x = (canvasRef.current.width - img.width * scaleFactor) / 2;
        const y = (canvasRef.current.height - img.height * scaleFactor) / 2;
        ctx.drawImage(img, x, y, img.width * scaleFactor, img.height * scaleFactor);
      };
      img.src = image;
    }
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <canvas
        ref={canvasRef}
        style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
        onMouseDown={handleMouseDown}
      />
      <div className="d-flex flex-column p-3" style={{position:'absolute',zIndex:2,background:'rgba(211, 211, 211, 0.2)', borderRadius:'10px'}}>
        <button className='btn btn-sm btn-light-danger mb-2' onClick={handleReset} >
            Erase All
        </button>
        <div className="separator border-2 my-3"></div>
        <label className='form-label mt-1'>Pen Color</label>
       
        <div className="btn-group-vertical align-items-center">
            
            <button className="btn btn-icon btn-light-info" onClick={()=>handleColorChange("purple")}><i className="bi bi-pencil-fill"></i></button>
            <button className="btn btn-icon btn-light-primary" onClick={()=>handleColorChange("blue")}><i className="bi bi-pencil-fill"></i></button>
            <button className="btn btn-icon btn-light-success" onClick={()=>handleColorChange("green")}><i className="bi bi-pencil-fill"></i></button>
            <button className="btn btn-icon btn-light-danger" onClick={()=>handleColorChange("red")}><i className="bi bi-pencil-fill"></i></button>
            <button className="btn btn-icon btn-light-warning" onClick={()=>handleColorChange("orange")}><i className="bi bi-pencil-fill"></i></button>
        </div>
       
        <div className="separator border-2 my-3"></div>
         
         <label className='form-label mt-1'>Pen Size</label>
         <input type="range" className="form-range" style={{width:"100px"}}  min="1" max="10" value={penSize} onChange={handleSizeChange} />
        
       
      </div>
     
    </div>
  );
};

export default Canvas;
